import {
  GET_COMBO_USER,
  GET_COMBO_USER_SUCCESS,
  GET_COMBO_USER_FAILURE,
  GET_CURRENT_USER,
  GET_CURRENT_USER_SUCCESS,
  GET_CURRENT_USER_FAILURE,
} from "./actionTypes";

export const getComboUser = () => ({
  type: GET_COMBO_USER,
});

export const getComboUserSuccess = (data) => ({
  type: GET_COMBO_USER_SUCCESS,
  payload: data,
});

export const getComboUserFailure = () => ({
  type: GET_COMBO_USER_FAILURE,
});
export const getCurrentUser = () => ({
  type: GET_CURRENT_USER,
});

export const getCurrentUserSuccess = (data) => ({
  type: GET_CURRENT_USER_SUCCESS,
  payload: data,
});

export const getCurrentUserFailure = () => ({
  type: GET_CURRENT_USER_FAILURE,
});
